export const getFulfilmentState = (fulfilmentState) => {
    switch (fulfilmentState) {
        case 'EMAIL_SENT':
            return "Email Sent to Donor";
        case 'USER_INFO_SUIBMITTED':
            return 'User Info Submitted';
        case 'SHIPPED':
            return 'Shipped';
        default:
            return 'Unknown';
    }
}

export const getBillStatus = (billStatusCode) => {
    switch (billStatusCode) {
        case 'NOT_PAID':
            return "Not Paid";
        case 'PAID':
            return 'Paid';
        case 'CANCELLED':
            return 'Refunded';
        default:
            return 'Unknown';
    }
}

export const getDonationStatus = (donationStatusCode) => {
    switch (donationStatusCode) {
        case 'NOT_PAID':
            return "Not Paid";
        case 'PAID':
            return 'Paid';
        case 'CANCELLED':
            return 'Refunded';
        default:
            return 'Unknown';
    }
}

export const getPaymentStatus = (paymentStatus) => {
    switch (paymentStatus) {
        case 'PAYMENT_SETUP':
            return 'Processing';
        case 'PAYMENT_PROCESSING':
            return 'Processing';
        case 'PAYMENT_SUCCEEDED':
            return 'Payment succeeded';
        case 'PAYMENT_FAILED':
            return 'Payment Failed';
        case 'PAYMENT_CANCELLED':
            return 'Payment Cancelled';
        case 'PAYMENT_DECLINED':
            return 'Payment Declined';
        case 'PAYMENT_REFUNDED':
            return 'Payment refunded';
        case 'PAYMENT_PENDING_APPROVAL':
            return 'Payment Pending Approval';
        default:
            return 'Unknown';
    }
}

export const getPaymentSourceType = (paymentSourceType) => {
    switch (paymentSourceType) {
        case 'CARD':
            return 'Credit/Debit Card';
        case 'BANK_DEBIT':
            return 'ACH/eCheck';
        case 'OFFLINE':
            return 'Offline Payment';

    }
}

export const getSponsorshipStatus = (status) => {
    switch (status) {
        case 'NOT_SPONSORED':
            return "Not Sponsored";
        case 'SPONSORED':
            return "Sponsored";
        case 'FULFILLED':
            return "Sponsorship fulfilled";
        case 'PENDING_APPROVAL':
            return "Pending Approval";
    }
}

export const getSponsorshipTypes = (status) => {
    switch (status) {
        case 'RECURRING':
            return "Recurring";
        case 'ONE_TIME':
            return "One time";
    }
}

export const getRecipientTypes = (status) => {
    switch (status) {
        case 'EVENT':
            return "Event";
        case 'STUDENT':
            return "Student";
        case 'HEALTH':
            return "Health";
        case 'ORPHAN':
            return "Orphan";
        case 'PLAYER':
            return "Player";
    }
}

export const getRecurringFrequency = (freq) => {
    switch (freq) {
        case 'ONE_TIME':
            return "One time";
        case 'DAILY':
            return "Daily";
        case 'WEEKLY':
            return "Weekly";
        case 'BIWEEKLY':
            return "Biweekly";
        case 'MONTHLY':
            return "Monthly";
        case 'QUARTERLY':
            return "Quarterly";
        case 'SEMIANNUALLY':
            return "Semianually";
        case 'ANNUALLY':
            return "Annually";
    }
}

export const getRole = (role) => {
    switch(role){
        case 'ROLE_BUSINESS_ADMIN':
            return "Adminstrator";
        case 'ROLE_CONSUMER':
            return "Consumer";
        case 'ROLE_DONATION_BOX':
            return 'Donation Box Admin';
        default:
        return "UNKNOWN";    
    }
}

